import { createServerFn } from "@tanstack/react-start";
import { contactSchema, leadMagnetSchema } from "./ghl.schema";

export const submitGHLContact = createServerFn({ method: "POST" })
  .inputValidator((data) => contactSchema.parse(data))
  .handler(async ({ data }) => {
    const { handleCaseReviewSubmission } = await import("./ghl.server");
    await handleCaseReviewSubmission(data);
    return { ok: true };
  });

export const submitGHLLeadMagnet = createServerFn({ method: "POST" })
  .inputValidator((data) => leadMagnetSchema.parse(data))
  .handler(async ({ data }) => {
    const { upsertContact } = await import("./ghl.server");

    const tags = [`lead-magnet-${data.guideSlug}`, "website-lead-magnet"];
    if (data.utmSource) tags.push(`utm:${data.utmSource}`);

    const notes = [
      `Downloaded guide: ${data.guideSlug}`,
      data.sourcePath ? `Page: ${data.sourcePath}` : null,
      `UTM: source=${data.utmSource ?? "-"} medium=${data.utmMedium ?? "-"} campaign=${data.utmCampaign ?? "-"}`,
    ]
      .filter(Boolean)
      .join("\n");

    await upsertContact({
      name: data.name,
      email: data.email,
      source: "Website (Lead Magnet)",
      tags,
      notes,
    });

    return { ok: true };
  });
